import { render, staticRenderFns } from "./viewPublish.vue?vue&type=template&id=64b57f59&"
import script from "./viewPublish.vue?vue&type=script&lang=js&"
export * from "./viewPublish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports